// @ts-nocheck
import React, { useState, useEffect } from "react";
import { supabase } from "../../../services/supabaseClient";
import { useAuth } from "../../../context/AuthContext"; // ✅ added
import "../MyAccountModal.css";

interface RetailerConnectionModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const RetailerConnectionModal: React.FC<RetailerConnectionModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { user } = useAuth();              // ✅ added
  const authId = user?.id;                 // ✅ added

  const [retailers, setRetailers] = useState<any[]>([]);
  const [connectedRetailers, setConnectedRetailers] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");

  useEffect(() => {
    if (isOpen) {
      loadData();
      setStatusMessage("");
    }
  }, [isOpen]);

  const loadData = async () => {
    if (!authId) return; // ✅ safety
    setLoading(true);

    const { data: allRetailers } = await supabase
      .from("retailers")
      .select("id, retailer");

    const { data: connections } = await supabase
      .from("user_retailers")
      .select("retailer_id")
      .eq("auth_id", authId);

    const connectedIds = connections?.map((c) => c.retailer_id) || [];

    setRetailers(allRetailers || []);
    setConnectedRetailers(
      allRetailers?.filter((r) => connectedIds.includes(r.id)) || []
    );

    setLoading(false);
  };

  const handleAddConnection = async (retailerId: number) => {
    if (!authId) return;
    setSaving(true);
    const { error } = await supabase
      .from("user_retailers")
      .insert([{ auth_id: authId, retailer_id: retailerId }]);
    if (error) console.error("Insert error:", error.message);
    setStatusMessage("✓ Connected");
    fadeStatus();
    await loadData();
    setSaving(false);
  };

  const handleRemoveConnection = async (retailerId: number) => {
    if (!authId) return;
    setSaving(true);
    const { error } = await supabase
      .from("user_retailers")
      .delete()
      .match({ auth_id: authId, retailer_id: retailerId });
    if (error) console.error("Delete error:", error.message);
    setStatusMessage("✕ Removed");
    fadeStatus();
    await loadData();
    setSaving(false);
  };

  const fadeStatus = () => setTimeout(() => setStatusMessage(""), 1600);

  const filteredRetailers = retailers.filter((r) =>
    r.retailer.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (!isOpen) return null;

  return (
    <div className="my-account-modal-overlay" onClick={onClose}>
      <div className="my-account-modal" onClick={(e) => e.stopPropagation()}>
        <div className="my-account-modal-header">
          <h2 className="my-account-modal-title">Retailer Connections</h2>
          <button className="my-account-modal-close-btn" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="my-account-modal-content">
          <div className="form-group">
            <label className="form-label">Search Retailers</label>
            <input
              type="text"
              className="form-input"
              placeholder="Search by retailer name..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          {statusMessage && (
            <div className="connection-status">{statusMessage}</div>
          )}

          {loading ? (
            <div className="connection-loading">Loading...</div>
          ) : (
            <div className="connection-list">
              {filteredRetailers.map((retailer) => {
                const isConnected = connectedRetailers.some(
                  (r) => r.id === retailer.id
                );
                return (
                  <div key={retailer.id} className="connection-list-item">
                    <span>{retailer.retailer}</span>
                    <div className="connection-actions">
                      {isConnected ? (
                        <button
                          onClick={() => handleRemoveConnection(retailer.id)}
                          className="remove-btn"
                          disabled={saving}
                        >
                          Remove
                        </button>
                      ) : (
                        <button
                          onClick={() => handleAddConnection(retailer.id)}
                          className="add-btn"
                          disabled={saving}
                        >
                          Add
                        </button>
                      )}
                    </div>
                  </div>
                );
              })}
              {filteredRetailers.length === 0 && (
                <div className="connection-empty">
                  No matching retailers found.
                </div>
              )}
            </div>
          )}
        </div>

        <div className="my-account-modal-footer">
          <button className="my-account-close-btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default RetailerConnectionModal;
